import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class BreakdownPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const breakdownPayload = widget.payload[selectedPoints[0].series.options.custom.payloadProp];

    payload.scene_params.metric_calculation = breakdownPayload.scoring;

    switch (breakdownPayload.metric) {
      case 'nps':
        payload.scene_params.metric_calculation = 'rating';
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = -100;
        payload.scene_params.worst_rating_value = breakdownPayload.min;
        payload.scene_params.best_rating_value = breakdownPayload.max;
        break;
      case 'box':
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = 0;
        payload.scene_params.box_options = `Top:${breakdownPayload.topBoxSize},Neutral,Bottom:${breakdownPayload.bottomBoxSize}`;
        break;
      case 'avg':
        payload.scene_params.rating_score_high = breakdownPayload.maxRating;
        payload.scene_params.rating_score_low = breakdownPayload.minRating;
        break;
    }

    payload.scene_params.rating_field = FieldService.getFieldLongName(
      breakdownPayload.numericMetadataFieldId
    );
    if (payload.scene_params.rating_field === 'docs') {
      payload.scene_params.rating_field = 'Documents';
      payload.scene_params.metric_calculation = 'count';
    }

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      let pointGroup = selectedPoints[pointIdx];
      if (!Array.isArray(selectedPoints[pointIdx])) {
        pointGroup = [selectedPoints[pointIdx]];
      }

      for (let comparisonIdx = 0; comparisonIdx < pointGroup.length; comparisonIdx++) {
        const bucket = payload.buckets[pointIdx * pointGroup.length + comparisonIdx];

        bucket.breakdown_filter_field_name = FieldService.getFieldLongName(
          widget.payload.analyticItem
        );
        bucket.breakdown_filter_field_value = bucket.analytic_item_value;

        delete bucket.analytic_item_type;
        delete bucket.analytic_item_value;
      }
    }

    return payload;
  }

  protected fillWidgetQueryOptionsForPoint(widgetQueryOptions: any, point: any): void {
    super.fillWidgetQueryOptionsForPoint(widgetQueryOptions, point);

    widgetQueryOptions.widgetContextMenu.series = {
      name: point.series.options.custom?.box ?? point.series.name,
    };
  }
}
